import React from 'react'
import { Card } from 'react-bootstrap';
import "./GalleryPage.css"
import { Link } from "react-router-dom";

export const GalleryPage = () => {

    return (
        <div className="GalleryPageContainer" style={{textAlign: 'center'}}>
        <Link to="/g/youtube" className="links">
          <div className="youtubeGalleryContainer">
            <Card className="youtubeCard" >
              <Card.Img variant="top" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/GalleryVid%2Fvid1.webp?alt=media&token=a22957a6-2b92-47af-a9ed-7e3893df4d69" />
              <Card.Body>
                <Card.Text className="youtube-card-text">
                <i className="fab fa-youtube"></i>
                  Youtube
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
         </Link>

         <Link to="/g/facebook" className="links">
          <div className="facebookGalleryContainer">
            <Card className="facebookCard" >
              <Card.Img variant="top" src="https://scontent.fixm2-1.fna.fbcdn.net/v/t31.0-8/981607_221679857995009_127910051_o.jpg?_nc_cat=111&ccb=1-3&_nc_sid=cdbe9c&_nc_ohc=aQCg7wxVk-sAX8Ck3bV&_nc_ht=scontent.fixm2-1.fna&oh=0fe66897ebe892e7e129e9fe47e7e86f&oe=606A67E6" />
              <Card.Body>
                <Card.Text className="facebook-card-text">
                <i className="fab fa-facebook"></i>
                  Facebook
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
         </Link>
        </div>
    )
}